import type { paths } from '@orlikfy/api-interfaces';

export {
  AdminGameDto,
  AdminGamePlayerDto,
  AdminUserDto,
  DailyStatsDto,
  GetAdminGamesStatsDto,
  PlatformStatsDto,
  PlatformVersionStatsDto,
  RegionDailyGamesStatsDto,
  RegionDailyRegistrationsDto,
  RegionGameStatsDto,
  RegionUserStatsDto,
  GetAdminUsersStatsDto,
  VersionStatsDto,
  RegionDto
} from '@orlikfy/api-interfaces';

// GET /admin/users
export const GET_ADMIN_USERS_PATH = '/admin/users' as const satisfies keyof paths;
type GetAdminUsersOperation = paths[typeof GET_ADMIN_USERS_PATH]['get'];
export type GetAdminUsersQueryParams = GetAdminUsersOperation['parameters']['query'];
export type GetAdminUsersResponse = GetAdminUsersOperation['responses'][200]['content']['application/json'];

// PATCH /admin/users/{userId}/moderation
export const SET_USER_MODERATION_FLAG_PATH = '/admin/users/{userId}/moderation' as const satisfies keyof paths;
type SetUserModerationFlagOperation = paths[typeof SET_USER_MODERATION_FLAG_PATH]['patch'];
export type SetUserModerationFlagPathParams = SetUserModerationFlagOperation['parameters']['path'];
export type SetUserModerationFlagBody = SetUserModerationFlagOperation['requestBody']['content']['application/json'];

// GET /admin/users/stats
export const GET_ADMIN_USERS_STATS_PATH = '/admin/users/stats' as const satisfies keyof paths;
type GetAdminUsersStatsOperation = paths[typeof GET_ADMIN_USERS_STATS_PATH]['get'];
export type GetAdminUsersStatsQueryParams = GetAdminUsersStatsOperation['parameters']['query'];
export type GetAdminUsersStatsResponse = GetAdminUsersStatsOperation['responses'][200]['content']['application/json'];

// GET /admin/games
export const GET_ADMIN_GAMES_PATH = '/admin/games' as const satisfies keyof paths;
type GetAdminGamesOperation = paths[typeof GET_ADMIN_GAMES_PATH]['get'];
export type GetAdminGamesQueryParams = GetAdminGamesOperation['parameters']['query'];
export type GetAdminGamesResponse = GetAdminGamesOperation['responses'][200]['content']['application/json'];

// GET /admin/games-for-post
export const GET_ADMIN_GAMES_FOR_POST_PATH = '/admin/games-for-post' as const satisfies keyof paths;
type GetAdminGamesForPostOperation = paths[typeof GET_ADMIN_GAMES_FOR_POST_PATH]['get'];
export type GetAdminGamesForPostQueryParams = GetAdminGamesForPostOperation['parameters']['query'];
export type GetAdminGamesForPostResponse =
  GetAdminGamesForPostOperation['responses'][200]['content']['application/json'];

// GET /admin/games/stats
export const GET_ADMIN_GAMES_STATS_PATH = '/admin/games/stats' as const satisfies keyof paths;
type GetAdminGamesStatsOperation = paths[typeof GET_ADMIN_GAMES_STATS_PATH]['get'];
export type GetAdminGamesStatsQueryParams = GetAdminGamesStatsOperation['parameters']['query'];
export type GetAdminGamesStatsResponse = GetAdminGamesStatsOperation['responses'][200]['content']['application/json'];

// GET /admin/known-cities
export const GET_ADMIN_KNOWN_CITIES_PATH = '/admin/known-cities' as const satisfies keyof paths;
type GetAdminKnownCitiesOperation = paths[typeof GET_ADMIN_KNOWN_CITIES_PATH]['get'];
export type GetAdminKnownCitiesResponse = GetAdminKnownCitiesOperation['responses'][200]['content']['application/json'];

// GET /admin/known-regions
export const GET_ADMIN_KNOWN_REGIONS_PATH = '/admin/known-regions' as const satisfies keyof paths;
type GetAdminKnownRegionsOperation = paths[typeof GET_ADMIN_KNOWN_REGIONS_PATH]['get'];
export type GetAdminKnownRegionsResponse =
  GetAdminKnownRegionsOperation['responses'][200]['content']['application/json'];
